import { render, staticRenderFns } from "./ClassDetails.vue?vue&type=template&id=36f5198b&scoped=true&"
import script from "./classdetails.js?vue&type=script&lang=js&"
export * from "./classdetails.js?vue&type=script&lang=js&"
import style0 from "./ClassDetails.vue?vue&type=style&index=0&id=36f5198b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5198b",
  null
  
)

export default component.exports